import React from 'react';
import { useSelector } from 'react-redux';

import {
  GoogleAnalyticsConstants,
  GoogleAnalyticsDisplayedEvent,
  GoogleAnalyticsEventContextWrapper,
} from '@vvoyages/google-analytics';

import Button from '@/components/Button';
import ExternalLink from '@/components/ExternalLink/ExternalLink';
import { WizardStep } from '@/components/Wizard';
import { CONTACT_US_URL } from '@/constants';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';
import { selectResources } from '@/reducers/common/selectors';

import styles from './ClaimBookingStep.module.scss';

type ClaimImportErrorProps = {
  tabId: string;
  connectBooking: Function;
};

const ClaimImportError: React.FC<ClaimImportErrorProps> = ({ tabId, connectBooking }) => {
  const appUiData = useAppUiData();
  const resources = useSelector(selectResources);
  return (
    <WizardStep tabId={tabId}>
      <GoogleAnalyticsEventContextWrapper category="VV-account-sign-in|importation-delayed-state">
        <GoogleAnalyticsDisplayedEvent eventAction={GoogleAnalyticsConstants.EVENT_ACTION.DISPLAYED} />
        <h2 className={styles.title}>{appUiData[appUiIds.importation.thatsAwkward]}</h2>
        <p className={styles.subtitle}>{appUiData[appUiIds.importation.tryAgainText]}</p>
        <Button variant="payment-card" onClick={connectBooking} className={styles.buttonConnectBooking}>
          {appUiData[appUiIds.importation.connectBooking]}
        </Button>
        <div className={styles.linkContainer}>
          <ExternalLink href={resources[CONTACT_US_URL]} name={appUiData[appUiIds.sailorServices]} />
        </div>
      </GoogleAnalyticsEventContextWrapper>
    </WizardStep>
  );
};

export default ClaimImportError;
